// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-content {
  border: 1px solid #ccc;
  margin: auto;
}

.content {
  visibility: hidden;
}

.a4 {
  width: 210mm;
  height: 297mm;
  visibility: visible;
}

.a3 {
  width: 297mm;
  height: 420mm;
  visibility: visible;
}

.letter {
  width: 8.5in;
  height: 11in;
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/TemplateDisplay/TemplatePagePreviewModal/pagePreview.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,YAAA;AACJ;;AAEE;EACE,kBAAA;AACJ;;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AACJ","sourcesContent":[".preview-content {\n    border: 1px solid #ccc; \n    margin: auto;\n  }\n  \n  .content {\n    visibility: hidden;\n  }\n  \n  .a4 {\n    width: 210mm;\n    height: 297mm;\n    visibility: visible;\n  }\n  \n  .a3 {\n    width: 297mm;\n    height: 420mm;\n    visibility: visible;\n  }\n  \n  .letter {\n    width: 8.5in;\n    height: 11in;\n    visibility: visible;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
